import {
  AfterContentInit, AfterViewChecked,
  AfterViewInit,
  Component, ComponentFactoryResolver,
  ContentChildren, ElementRef,
  HostListener,
  Inject,
  OnInit,
  QueryList, Renderer2, TemplateRef,
  ViewChild, ViewChildren
} from '@angular/core';
import {DotComponent} from '../dot/dot.component';
import {DOCUMENT} from '@angular/common';

@Component({
  selector: 'app-dotnav',
  templateUrl: './dotnav.component.html',
  styleUrls: ['./dotnav.component.scss']
})
export class DotnavComponent implements AfterViewChecked, OnInit {

  @ContentChildren(DotComponent) dots: QueryList<DotComponent>;


  constructor(@Inject(DOCUMENT) private document: Document) { }

  ngOnInit() {
  }

  ngAfterViewChecked(): void {
    this.updateNavigation();
  }

// ( top - window.innerHeight / 2 < window.pageYOffset ) &&
// ( top + el.scrollHeight - window.innerHeight / 2 > window.pageYOffset )
  @HostListener('window:scroll', ['$event'])
  onScroll() {
    this.updateNavigation();
  }

  private updateNavigation() {
    console.log('updating navigation');
    let selected = false;
    this.dots.forEach((item, index, items) => {
      const elementId = item.navigateTo;
      const el = this.document.getElementById(elementId);
      const top = el.getBoundingClientRect().top;
      const bottom = el.getBoundingClientRect().bottom;
      if ( ((top >= -2 && top < window.innerHeight / 2) ||
        (bottom > window.outerHeight - window.pageYOffset && bottom < window.innerHeight / 2 )) && !selected) {
        item.selected = true;
        selected = true;
      } else {
        item.selected = false;
      }
    });
  }

}
